module.exports = __webpack_public_path__ + "static/media/t9.3ddc2235.png";